import React from "react";
import Skeleton from "react-loading-skeleton";
import styles from "./HorizontalSuiteCardBase.module.scss";

export const HorizontalSuiteCardSkeleton: React.FC<unknown> = () => {
  return (
    <div className={styles.card}>
      <div className={styles.image}>
        <Skeleton height="100%" />
      </div>

      <div className={styles.title}>
        <Skeleton height={40} />
      </div>

      <ul className={styles.features}>
        <li>
          <Skeleton count={1} width="80%" />
        </li>
        <li>
          <Skeleton count={1} width="80%" />
        </li>
        <li>
          <Skeleton count={1} width="80%" />
        </li>
        <li>
          <Skeleton count={1} width="80%" />
        </li>
      </ul>

      <div className={styles.pricesColumn}>
        <div className={styles.prices}>
          <Skeleton count={1} width="100px" height={36} />
          <Skeleton count={1} width="100px" height={36} />
        </div>
      </div>
      <div className={styles.footer}>
        <Skeleton count={1} height={44} width={160} />
        <Skeleton count={1} height={44} width={160} />
      </div>
    </div>
  );
};
